import { pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Item = styled.div `
  padding-bottom: ${theme.spacing.xl};

  &:not(:last-child) {
    margin-bottom: ${theme.spacing.xl};
  }

  border-bottom: solid ${pxToRem(1)} ${theme.semantic.border.default};
`;
export const TitleContainer = styled.div `
  display: flex;
  align-items: center;
  margin-bottom: ${theme.spacing.md};
`;
export const ActionsContainer = styled.div `
  margin-left: auto;
`;
